import concat from "lodash/concat";
import dropRight from "lodash/dropRight";
import filter from "lodash/filter";
import { ComponentPublicInstance, ref, Ref } from "vue";
import { DEFAULT_NOTIFICATION_DURATION, MAX_NOTIFICATIONS } from "@/src/easy-ui/constants/easyNotifications";
import { EasyAlerts } from "@/src/easy-ui/types";
import { EasyNotificationPayload, EasyNotificationProps } from "@/src/easy-ui/types/easyNotifications";
import { generateUUID } from "@/src/shared/utils/uuid";

class EasyNotificationsStore {
  private static instance?: EasyNotificationsStore;

  public easyNotificationsApp: ComponentPublicInstance<unknown> | null;

  public notifications: Ref<EasyNotificationProps[]>;

  private constructor() {
    this.notifications = ref([]);
    this.easyNotificationsApp = null;
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new EasyNotificationsStore();
    }

    return this.instance;
  }

  public addNotification({
    duration = DEFAULT_NOTIFICATION_DURATION,
    type = EasyAlerts.Error,
    title,
    message,
  }: EasyNotificationPayload) {
    this.notifications.value = concat(
      [{ duration, type, title, message, id: generateUUID() }],
      this.notifications.value
    );

    if (this.notifications.value.length > MAX_NOTIFICATIONS) {
      this.notifications.value = dropRight(this.notifications.value);
    }
  }

  public removeNotification(id: string) {
    this.notifications.value = filter(this.notifications.value, n => n.id !== id);
  }
}

export default EasyNotificationsStore.getInstance();
